import PropTypes from 'prop-types';
import { Button } from '@schibsted-svp/react-ui';
import { bemgen } from 'lib/bem';
import { FiltersDialog } from 'components/core/FiltersDialog';
import './FiltersButton.scss';

function FiltersButton({ hideStatusField = false, setFilters = () => {}, ...rest }) {
    return (
        <FiltersDialog
            containerClassName={bemgen('FiltersButton')}
            hideStatusField={hideStatusField}
            onFilter={setFilters}
            dialogTrigger={(onClick) => (
                <Button onClick={onClick} type="button" variant="standard">
                    Filters
                </Button>
            )}
            {...rest}
        />
    );
}

FiltersButton.propTypes = {
    hideStatusField: PropTypes.bool,
    setFilters: PropTypes.func,
};

export default FiltersButton;
